"use strict";
var Cache_1 = require('../Cache');
var MixinUtil_1 = require('../MixinUtil');
var PopStore = (function () {
    function PopStore() {
        // Cache impl
        this._cache = {};
    }
    return PopStore;
}());
exports.PopStore = PopStore;
MixinUtil_1.default.applyMixins(PopStore, [Cache_1.default]);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new PopStore();
